import resume from '../assets/pdf/resume.pdf'
import profileImage from '../assets/png/me.png'

export const headerData = {
    name: 'Khashayar Kazemi',
    title: 'Senior DevOps Engineer',
    roles: [
        'Senior DevOps Engineer',
        'Cloud Infrastructure Architect',
        'Kubernetes & CI/CD Specialist',
        'Security & Observability Engineer',
    ],
    location: 'Vienna, Austria',
    description:
        "I design, secure, and scale cloud infrastructure — from AWS environments to GitHub Actions CI/CD pipelines to the observability stack that keeps it all honest. Currently focusing heavily on site reliability at hokify, maintaining AWS infrastructure and CI/CD, running a managed OpenSearch cluster, and building out best-practice security and observability procedures.",
    image: profileImage,
    resumePdf: resume,
}
